import {FC, useEffect, useState} from "react";
import {Modal, Spin, UploadFile} from "antd";
import {HomeGalleryModalProps} from "./types";
import Uploader from "../../uploader/Uploader";
import * as BUCKETS from "../../../enums/buckets";
import {getImageLink} from "../../../helpers/mainHelpers";
import "./style.less"

const HomeGalleryModal: FC<HomeGalleryModalProps> = (props) => {
  const {galleryController} = props
  const {isImagesLoading, isModalOpen, toggleGalleryModal, images, updateGalleryImages} = galleryController
  const title = "Редагування галереї"
  const [uploadImages, setUploadImages] = useState<UploadFile[]>([])

  useEffect(() => {
    if (images.length) {
      const imagesData = images.map((imageId) => {
        return {
          uid: imageId,
          name: imageId,
          url: getImageLink({imageId: imageId, bucketId: BUCKETS.MAIN}),
          response: {$id: imageId}
        }
      })
      setUploadImages(imagesData)
    }
  }, [images])

  const saveButtonHandler = async () => {
    const imagesIds = uploadImages.map((image) => image.response.$id)
    await updateGalleryImages(imagesIds)
  }


  return <Modal className="updateGallery_modal" width={900} style={{top: 20}} title={title} open={isModalOpen}
                onOk={saveButtonHandler}
                onCancel={toggleGalleryModal}
                cancelButtonProps={{title: "Закрити"}} okButtonProps={{title: "Зберегти"}}>
    <Spin spinning={isImagesLoading}>
      <div className="galleryUploader_wrapper">
        <Uploader files={uploadImages} setFiles={setUploadImages}
                  bucketId={BUCKETS.MAIN}/>
      </div>
    </Spin>
  </Modal>
}

export default HomeGalleryModal